import { InputField } from "../../common/theme/Input";
import { useFormik } from "formik";
import styles from "../../scss/common/common.module.scss";
import Grid from "@mui/material/Grid";
import { shippingMethodForm } from "../../validations/CheckoutSchema";
import { useSelector, useDispatch } from "react-redux";
import { setCheckoutSecondFormSlice } from "../../redux/CheckoutForm/CheckoutFormSlice";
import React, { useEffect, useState } from "react";
import useFetch from "../../customHook/useFetch";
import { toast } from "react-toastify";
import { Autocomplete, InputLabel, TextField } from "@mui/material";
import AppButton from "../../common/theme/Button";
import LoadingBars from "../../common/sections/LoadingBars";
import { RotatingLines } from "react-loader-spinner";
const _ = require("lodash");

interface IProps {
  selected?: any;
  formInfo?: any;
  ShowSpecificForm?: any;
  billingAddress?: boolean;
  isLoading?: boolean;
  placeOrder: (first: any, shipping: any) => void;
  setSummaryData: any;
  summaryData: any;
  isCollectTax: boolean;
  cartChangesPending?: boolean;
}

interface clubStateListApi {
  id: number;
  state_name: string;
}

const CheckoutShipmentForm = ({
  selected,
  formInfo,
  ShowSpecificForm,
  billingAddress,
  isLoading,
  placeOrder,
  setSummaryData,
  summaryData,
  isCollectTax,
  cartChangesPending = false,
}: IProps) => {
  const dispatch = useDispatch();

  const [selectedFilter, setSelectedFilter] = useState<any>({
    label: "",
    value: 0,
  });
  const [clubStateList, setClubStateList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [addressVerified, setAddressVerified] = useState<boolean | null>(null);
  const [formValues, setFormValues] = useState<any>();
  const [placeOrderDisable, setPlaceOrderDisable] = useState(true);
  const [
    getClubStateList,
    { response: getClubStateResponse, error: getClubStateError },
  ] = useFetch("/us-states/list?start=0&limit=-1", {
    method: "get",
  });
  const [
    validateAddress,
    {
      response: validateAddressResponse,
      error: validateAddressError,
      loading: validateAddressLoading,
    },
  ] = useFetch("/validate-address", {
    method: "post",
  });
  const storeDesignSettingData = useSelector(
    (state: any) => state.storeCheckoutForm.SecondFormSlice
  );

  useEffect(() => {
    if (storeDesignSettingData?.state) {
      setSelectedFilter(
        clubStateList?.find(
          (item: any) => item?.value === storeDesignSettingData?.state
        )
      );
    }
  }, [clubStateList]);

  const [taxAutomatically, setTaxAutomatically] = useState<number | null>(null);

  /** Get tax api calling start */
  const [getTaxApi, { loading: taxLoading }] = useFetch(
    `/get-tax/${formValues?.zipCode}`,
    {
      method: "get",
    }
  );
  const callGetTaxApi = async () => {
    const response = await getTaxApi();
    if (response?.data?.status && response?.data?.data) {
      setSummaryData({
        ...summaryData,
        tax:
          summaryData.tax_type === 1
            ? Number(response?.data?.data?.combined_rate)
            : summaryData.tax,
      });
      setTaxAutomatically(Number(response?.data?.data?.combined_rate));
      setPlaceOrderDisable(false);
    } else {
      toast.error("Invalid zip code");
    }
  };

  const handleValidateAddress = async (params: any) => {
    setAddressVerified(null);
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);
      formik.setTouched(errors);
      return;
    }
    const stateName: any = stateList?.find(
      (item: any) => item.id === params.state
    );
    validateAddress({
      address_line1: params.street.trim(),
      city_locality: params.city.trim(),
      state_province: stateName?.short_name ?? "",
      postal_code: params.zipCode.trim(),
      country_code: "US",
    });
  };
  const formik: any = useFormik({
    initialValues: {
      firstName: storeDesignSettingData.firstName,
      lastName: storeDesignSettingData.lastName,
      street: storeDesignSettingData.street,
      aptUnit: storeDesignSettingData.aptUnit,
      state: storeDesignSettingData.state,
      zipCode: storeDesignSettingData.zipCode,
      city: storeDesignSettingData.city,
    },
    validationSchema: shippingMethodForm,
    onSubmit: (values) => {
      if (cartChangesPending) {
        toast.error(
          "Accept the item changes or remove the item before continuing."
        );
        return;
      }
      if (isCollectTax) {
        if (values?.zipCode === formValues?.zipCode) {
          // setSummaryData((pre: any) => ({ ...pre, tax: taxAutomatically }));
          dispatch(setCheckoutSecondFormSlice(formValues));
          if (ShowSpecificForm?.PaymentForm === true) {
            selected(2);
          }
        } else {
          setFormValues(values);
        }
      } else {
        dispatch(setCheckoutSecondFormSlice(values));
        if (ShowSpecificForm?.PaymentForm === false) {
          // Api will hit
          placeOrder(null, values);
        } else {
          selected(2);
        }
      }
    },
  });

  useEffect(() => {
    if (taxAutomatically !== null) {
      // setSummaryData((pre: any) => ({ ...pre, tax: taxAutomatically }));
      dispatch(setCheckoutSecondFormSlice(formValues));
      // setFormValues({});
      // setTaxAutomatically(0);
      if (ShowSpecificForm?.PaymentForm === true) {
        selected(2);
      }
    }
  }, [taxAutomatically]);

  useEffect(() => {
    if (formValues?.zipCode) {
      callGetTaxApi();
    }
  }, [formValues]);

  useEffect(() => {
    getClubStateList();
  }, []);

  useEffect(() => {
    if (validateAddressResponse?.status) {
      const { data } = validateAddressResponse;
      if (data?.status === "verified") {
        const originalPostal = data.original_address.postal_code;
        const matchedPostal = data.matched_address.postal_code;
        if (matchedPostal.includes(originalPostal)) {
          setAddressVerified(true);
        } else {
          setAddressVerified(false);
        }
      } else {
        setAddressVerified(false);
        toast.error(validateAddressError?.message);
      }
    }
  }, [validateAddressResponse, validateAddressError]);
  useEffect(() => {
    if (getClubStateResponse?.status) {
      setStateList(getClubStateResponse?.data?.list);
      const options = getClubStateResponse?.data?.list.map(
        (data: clubStateListApi) => ({
          label: data?.state_name,
          value: data?.id,
        })
      );
      if (options.length) setClubStateList(options.reverse());
    } else {
      toast.error(getClubStateError?.message);
    }
  }, [getClubStateResponse, getClubStateError]);

  useEffect(() => {
    setAddressVerified(null);
    if (_.isEqual(formValues, formik?.values)) {
      setPlaceOrderDisable(false);
    } else {
      setPlaceOrderDisable(true);
    }
  }, [formik?.values]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className={styles.CheckoutCart}>
          <Grid item lg={6} xs={12}>
            <InputField
              required
              formik={formik}
              label="First Name"
              placeholder="Enter first name"
              name="firstName"
            />
          </Grid>
          <Grid item lg={6} xs={12}>
            <InputField
              required
              formik={formik}
              label="Last Name"
              placeholder="Enter last name"
              name="lastName"
            />
          </Grid>
          <Grid item lg={6} xs={12}>
            <InputField
              required
              formik={formik}
              label="Street"
              placeholder="Enter street"
              name="street"
              // disabled={true}
            />
          </Grid>
          <Grid item lg={6} xs={12}>
            <InputField
              formik={formik}
              label="Apt/Unit"
              placeholder="Enter apt/unit"
              name="aptUnit"
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <InputField
              required
              formik={formik}
              label="City"
              placeholder="Enter city"
              name="city"
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            {/* <SelectField
              required
              label="State"
              name="state"
              placeholder="Select state"
              formik={formik}
              options={clubStateList}
            /> */}
            <div className={`form_control statusWrap`}>
              <InputLabel className="form_label">
                State<sup>*</sup>
              </InputLabel>
              <Autocomplete
                options={clubStateList}
                className={`form_select`}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select state" />
                )}
                classes={{
                  popper: "customPopper",
                }}
                value={selectedFilter}
                onChange={(event, values) => {
                  setSelectedFilter(values);
                  formik?.setFieldValue("state", values?.value || "");
                }}
              />
              <div className="error">
                {formik?.touched.state && formik?.errors.state}
              </div>
            </div>
          </Grid>
          <Grid item lg={6} xs={12}>
            <InputField
              required
              formik={formik}
              label="Zip Code"
              placeholder="Enter zip code"
              name="zipCode"
            />
          </Grid>
          <Grid item lg={6} xs={12} style={{ display: "grid" }}>
            <AppButton
              type="button"
              disabled={validateAddressLoading}
              style={{ marginTop: "1.5rem", width: "fit-content" }}
              onClick={() => {
                handleValidateAddress(formik.values);
              }}
            >
              Validate Address
              {validateAddressLoading ? (
                <span
                  className="loadingBars"
                  style={{ display: "flex", marginRight: "5px" }}
                >
                  <RotatingLines
                    strokeColor="currentColor"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                  />
                </span>
              ) : (
                ""
              )}
            </AppButton>
            {addressVerified !== null ? (
              addressVerified ? (
                <span className={styles.addressVerified}>Address Verified</span>
              ) : (
                <span className={styles.addressNotVerified}>
                  Address Not Verified
                </span>
              )
            ) : null}
          </Grid>
        </Grid>

        <div className={styles.shoppingChat_checkoutBtn}>
          {ShowSpecificForm?.PaymentForm === true && (
            <AppButton
              type="submit"
              className={`${styles.continue} ${
                cartChangesPending ? styles.cartChangeBlocked : ""
              }`}
              // onClick={GoToNextPage}
              disabled={taxLoading || !addressVerified || cartChangesPending}
            >
              Save & Continue {taxLoading && <LoadingBars />}
            </AppButton>
          )}

          {ShowSpecificForm?.PaymentForm === false && (
            <>
              {isCollectTax && (
                <AppButton
                  type="submit"
                  className={`${styles.continue} ${
                    cartChangesPending ? styles.cartChangeBlocked : ""
                  }`}
                  disabled={isLoading || cartChangesPending}
                >
                  Save
                </AppButton>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AppButton
                  className={`${styles.continue} ${
                    cartChangesPending ? styles.cartChangeBlocked : ""
                  }`}
                  style={{ marginBottom: "10px" }}
                  disabled={
                    cartChangesPending ||
                    (isCollectTax &&
                      (isLoading ||
                        taxAutomatically === null ||
                        placeOrderDisable))
                  }
                  onClick={() => placeOrder(null, formik.values)}
                >
                  Place Order
                </AppButton>
                {isCollectTax && (
                  <span style={{ color: "rgb(136 136 137)", fontSize: "14px" }}>
                    Click Save to Continue
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </form>
    </>
  );
};

export default CheckoutShipmentForm;
